import styled from 'styled-components'

export const ExperienceContainer = styled.div`
  height: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #270F34;

  @media screen and (max-width: 1000px) {
    height: 2000px;
    }

  @media screen and (max-width: 800px) {
    height: 2400px;
  }
`

export const ExperienceWrapper = styled.div`
    max-width: 1000px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: center;
    grid-gap: 16px;
    padding: 0 50px;

    @media screen and (max-width: 1000px) {
      grid-template-columns: 1fr 1fr;
  }

    @media screen and (max-width: 786px) {
      grid-template-columns: 1fr;
      padding: 0 20px;
  }
`

export const ExperienceCard = styled.div`
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    max-height: 340px;
    padding:  30px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    transition: all 0.2s ease-in-out;
    &:hover {
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
    }
`

export const ExperienceIcon = styled.img`
    height: 160px;
    width: 160px;
    margin-bottom: 10px;
`

export const ExperienceH1 = styled.h1`
    font-size: 2.5rem;
    color: #ff9d76;
    margin-bottom: 64px;

    @media screen and (max-width: 840px) {
      font-size: 1.5rem;
      margin-bottom: 34px;
    }

    @media screen and (max-width: 480px) {
        margin-bottom: 64px;
        font-size: 1rem;
    }
`

export const ExperienceH2 = styled.h2`
    font-size: 1rem;
    margin-bottom: 10px;
`

export const ExperienceH3 = styled.h3`
    color: #808080;
    font-size: 0.8rem;
    margin-bottom: 10px;
`

export const ExperienceP = styled.p`
    font-size: 0.8rem;
    text-align: center;
`
